import { IconType } from '@/components/icon/helpers';

export type RouteKey =
  | 'user-events'
  | 'insights'
  | 'default-policy-v1'
  | 'default-policy'
  | 'group-policies'
  | 'scope-policies'
  | 'override-policy'
  | 'public-services'
  | 'private-models'
  | 'data-sources'
  | 'agents'
  | 'classifiers'
  | 'org-settings'
  | 'admin-users'
  | 'users'
  | 'groups'
  | 'connectors'
  | 'telemetry'
  | 'mcp-servers'
  | 'audit-logs';

type RouteItem = {
  label: string;
  icon: IconType;
  link: string;
};

export const ROUTE_MAP: Record<RouteKey, RouteItem> = {
  'user-events': {
    label: 'User Activity',
    icon: 'chat',
    link: '/user-events',
  },
  insights: {
    label: 'Insights',
    icon: 'bar-chart',
    link: '/insights',
  },
  'default-policy-v1': {
    label: 'Default Policy',
    icon: 'policy',
    link: '/config/default-policy',
  },
  'group-policies': {
    label: 'Group Policies',
    icon: 'groups',
    link: '/config/group-policies',
  },
  'default-policy': {
    label: 'Default Policy',
    icon: 'policy',
    link: '/config/policy/default',
  },
  'scope-policies': {
    label: 'Scoped Policies',
    icon: 'group-work',
    link: '/config/policy/scoped',
  },
  'override-policy': {
    label: 'Override Policy',
    icon: 'emergency',
    link: '/config/policy/override',
  },
  'public-services': {
    label: 'Public Services',
    icon: 'cloud',
    link: '/config/public-services',
  },
  'private-models': {
    label: 'Private Models',
    icon: 'models',
    link: '/config/private-models',
  },
  'data-sources': {
    label: 'Data Sources',
    icon: 'doc-search',
    link: '/config/data-sources',
  },
  agents: {
    label: 'Assistants',
    icon: 'assistant',
    link: '/config/assistants',
  },
  classifiers: {
    label: 'Classifiers',
    icon: 'classifier',
    link: '/config/classifiers',
  },
  'org-settings': {
    label: 'Organization',
    icon: 'organization',
    link: '/config/org-settings',
  },
  'admin-users': {
    label: 'Admin Users',
    icon: 'certificate',
    link: '/config/admin-users',
  },
  users: {
    label: 'End Users',
    icon: 'person',
    link: '/config/end-users',
  },
  groups: {
    label: 'Groups',
    icon: 'group',
    link: '/config/groups',
  },
  connectors: {
    label: 'Connectors',
    icon: 'device-hub',
    link: '/config/connectors',
  },
  telemetry: {
    label: 'Telemetry',
    icon: 'telemetry',
    link: '/config/telemetry-destinations',
  },
  'mcp-servers': {
    label: 'MCP Servers',
    icon: 'mcp-server',
    link: '/config/mcp-servers',
  },
  'audit-logs': {
    label: 'Audit Logs',
    icon: 'logs',
    link: '/config/audit-logs',
  },
};

export const getRoute = (key: RouteKey): RouteItem => ROUTE_MAP[key];
